import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../components/LogIn'
import MainContainer from '../components/MainContainer'
import PackagesList from '../components/PackagesList'
import EcrList from '../components/ecr/EcrList'
import HouseShipmentList from '../components/ecr/HouseShipmentList'
import CreatePackageMaster from '../components/CreatePackageMaster'
import CommissionShipmentForm from '../components/documents/commission_shipment/CommissionShipmentForm'
import HouseShipmentForm from '../components/documents/ecr/HouseShipmentForm'
import EcrForm from '../components/documents/ecr/EcrForm'
import UserWithoutAccessRights from '../components/UserWithoutAccessRights'
import PageNotFound from '../components/PageNotFound'
import { store } from '../store/index'

Vue.use(VueRouter)

const ifAuthenticated = (to, from, next) => {
  if (store.getters['authorization/isAuthenticated']) {
    next()
    return
  }
  next('/login')
}

const routes = [
  {
    path: '/',
    name: 'MainContainer',
    component: MainContainer,
    beforeEnter: ifAuthenticated,
    meta: { name: 'Онлайн' },
    children: [
      {
        path: '/packages',
        name: 'PackagesList',
        component: PackagesList,
        beforeEnter: ifAuthenticated,
        meta: { name: 'Список пакетов', prevented: false }
      },
      {
        path: '/packages/new',
        name: 'CreatePackageMaster',
        component: CreatePackageMaster,
        beforeEnter: ifAuthenticated,
        meta: { name: 'Выберите тип пакета', prevented: false }
      },
      {
        path: '/packages/commission-shipment/new',
        name: 'AddNewCommissionShipment',
        component: CommissionShipmentForm,
        beforeEnter: ifAuthenticated,
        meta: { name: 'Создать Поручение на погрузку', prevented: true }
      },
      {
        path: '/packages/commission-shipment/:pid',
        component: CommissionShipmentForm,
        name: 'EditCommissionShipment',
        meta: { name: 'Редактировать Поручение на погрузку', prevented: true },
        beforeEnter: ifAuthenticated
      },
      {
        path: '/ecr',
        name: 'EcrList',
        component: EcrList,
        beforeEnter: ifAuthenticated,
        meta: { name: 'Список РЭГ', prevented: false }
      },
      {
        path: '/ecr/house-shipment',
        name: 'HouseShipmentList',
        component: HouseShipmentList,
        beforeEnter: ifAuthenticated,
        meta: { name: 'Товарные партии', prevented: false }
      },
      {
        path: '/ecr/house-shipment/new',
        name: 'AddHouseShipment',
        component: HouseShipmentForm,
        beforeEnter: ifAuthenticated,
        meta: { name: 'Создать Товарную партию', prevented: true }
      },
      {
        path: '/ecr/house-shipment/:pid',
        name: 'EditHouseShipment',
        component: HouseShipmentForm,
        meta: { name: 'Редактировать Товарную партию', prevented: true },
        beforeEnter: ifAuthenticated
      },
      {
        path: '/ecr/new',
        name: 'AddEcr',
        component: EcrForm,
        beforeEnter: ifAuthenticated,
        meta: { name: 'Создать Реестр экспресс грузов', prevented: true }
      },
      {
        path: '/ecr/:pid',
        name: 'EditEcr',
        component: EcrForm,
        meta: { name: 'Редактировать Реестр экспресс грузов', prevented: true },
        beforeEnter: ifAuthenticated
      },
      {
        path: '/without-access-rights',
        name: 'UserWithoutAccessRights',
        component: UserWithoutAccessRights,
        beforeEnter: ifAuthenticated,
        meta: { name: 'Главная' }
      }
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '*', component: PageNotFound
  }
]

const router = new VueRouter({
  routes
})

export default router
